/**
 * @file useOrderTabRevisit.ts
 * @description Тихое обновление вкладки карточки заказа при возврате на неё
 * (phase19.31, исправление «нижняя часть заказа перегружает страницу»).
 *
 * Открытые вкладки карточки остаются смонтированными (скрыты, а не удалены):
 * при повторном открытии прежние данные видны сразу — без пустоты со
 * спиннером, а шторки, раскрытые строки и прокрутка сохраняются. Чтобы при
 * этом не показывать устаревшее (платёж мог появиться из другой вкладки),
 * вкладка перечитывает свой список при каждом возвращении — тихо, поверх
 * прежних данных. Первое открытие обслуживает собственная загрузка вкладки.
 */

import { useEffect, useRef } from "react";

export function useOrderTabRevisit(active: boolean, reload: () => unknown): void {
  // Последняя версия перечитывания — без неё эффект зависел бы от функции,
  // которую вкладки создают заново на каждой отрисовке.
  const reloadRef = useRef(reload);
  reloadRef.current = reload;
  const wasActive = useRef(active);

  useEffect(() => {
    if (active && !wasActive.current) void reloadRef.current();
    wasActive.current = active;
  }, [active]);
}
